const hyphenate =require('./hyphenate');

module.exports = name => hyphenate(name).toLowerCase();
